import { render, staticRenderFns } from "./corporate-records-more.html?vue&type=template&id=ecdc6fc2&scoped=true&"
import script from "./corporate-records-more.js?vue&type=script&lang=js&"
export * from "./corporate-records-more.js?vue&type=script&lang=js&"
import style0 from "./corporate-records-more.scss?vue&type=style&index=0&id=ecdc6fc2&prod&scoped=true&lang=scss&"
import style1 from "./../monitoring-differential-highlighter/monitoring-differential-highlighter.scss?vue&type=style&index=1&id=ecdc6fc2&prod&scoped=true&lang=scss&"
import style2 from "./index.vue?vue&type=style&index=2&id=ecdc6fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdc6fc2",
  null
  
)

export default component.exports